import deepFreeze from '@/utils/deepFreeze'
import apiBus from '@/api/bus'
// import { BUS_COLORS } from '@/app.config'

const state = {
  busList: [],
  status: '',
  failMsg: '',
  selectedBus: null
}

const mutations = {
  SET_BUS_LIST (state, busList) {
    state.busList = deepFreeze(busList)
  },
  SET_STATUS (state, status) {
    state.status = status
  },
  SET_SELECTED_BUS (state, id) {
    state.selectedBus = id
  },
  SET_FAIL_MSG (state, msg) {
    state.failMsg = msg
  }
}

const actions = {
  setBusList ({ commit }, busList) {
    commit('SET_BUS_LIST', busList)
  },
  getBusList ({ commit, dispatch }) {
    apiBus
      .getList()
      .then(({ data: { data } }) => {
        dispatch('setBusList', data)
        commit('SET_STATUS', 'success')
      })
      .catch(({ response: { data: { message = 'Алдаа' } } }) => {
        commit('SET_STATUS', 'fail')
        commit('SET_FAIL_MSG', message)
      })
  },
  select ({ commit }, id) {
    commit('SET_SELECTED_BUS', id)
  }
}

const getters = {
  succeed: state => state.status === 'success',
  selectedBus: state => state.selectedBus,
  busList: state => state.busList.map(({
    id,
    name,
    color,
    trackPoint: {
      position: { longitude, latitude },
      velocity: { heading }
    }
  }) => {
    // if (!BUS_COLORS.includes(color)) {
    //   color = BUS_COLORS[0]
    // }
    return {
      id,
      name,
      color,
      longitude,
      latitude,
      heading
    }
  })
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
